import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Eye } from "lucide-react";

/**
 * Director's Debug Mode — visible ONLY to the Root Admin. Because Root Admin always bypasses
 * every gate (isPremiumUnlocked/isBusinessActive), they never naturally see a feature's
 * "locked" state to sanity-check the gating logic. This tiny tag annotates a gated control
 * with exactly which tier a normal user would need, so the Commander can verify correctness
 * just by looking at the screen — no second test account, no clicking required.
 */
const DirectorDebugTag = ({ requiredTier }) => {
  const { user } = useAuth();
  if (!user?.is_root_admin) return null;
  return (
    <span
      data-testid="director-debug-tag"
      title="Director's Debug Mode — visible only to you"
      className="inline-flex items-center gap-1 text-[9px] uppercase tracking-wide px-1.5 py-0.5 rounded-full border ml-1"
      style={{ borderColor: "#c9a24a", color: "#8a6a2a", background: "rgba(201,162,74,0.12)" }}
    >
      <Eye className="w-2.5 h-2.5" /> Gated: {requiredTier}
    </span>
  );
};

export default DirectorDebugTag;
